import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiSnackbar: {
      defaultProps: {
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
        autoHideDuration: 5000,
      },
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx } }) =>
          sx({
            '.MuiAlert-root': {
              minWidth: 300,
              fontWeight: 600,
            },
          }),
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          alignItems: 'center',
          fontSize: 16,
          fontWeight: 600,
          lineHeight: 1.5,
          borderRadius: 8,
        },
      },
    },
  },
});

export default theme.components;
